app.constant('constants', {
    lsTraderName: '__trm_',
    errorCodes: {
        invalidLogin: '-1'
    },
    currencySeparator: '',
    assetsTypes: [
        {id: 'FOREX', name: 'forex', selected: true},
        {id: 'CRYPTO', name: 'crypto', selected: false},
        {id: 'COMMODITIES', name: 'commodities', selected: false},
        {id: 'SHARES', name: 'stocks', selected: false},
        {id: 'INDICES', name: 'indices', selected: false},
        {id: 'Asian Shares', name: 'asiashares', selected: false},
        {id: 'Canadian Shares', name: 'canadianshares', selected: false},
        {id: 'EURO Shares', name: 'europeshares', selected: false},
        {id: 'UK Shares', name: 'ukshares', selected: false},
        {id: 'US Shares', name: 'usshares', selected: false}
    ],
    actions: {
        buy: 0,
        sell: 1,
        buy_limit: 2,
        sell_limit: 3,
        buy_stop: 4,
        sell_stop: 5,
        balance: 6,
        credit: 7,
        pamm: 8,
        correction: 9,
        charge: 10,
        commission: 11,
        commission_daily: 12,
        commission_monthly: 13,
        agent_daily: 14,
        agent_monthly: 15,
        interestrate: 16,
        buy_canceled: 17,
        sell_canceled: 18,
        dividend: 19,
        dividend_franked: 20,
        tax: 21,
        agent: 22,
        so_compensation: 23,
        bonus: 24
    },
    actionsId: {
        0: 'buy',
        1: 'sell',
        2: 'buy_limit',
        3: 'sell_limit',
        4: 'buy_stop',
        5: 'sell_stop',
        6: 'balance',
        7: 'credit',
        8: 'pamm',
        9: 'correction',
        10: 'charge',
        11: 'commission',
        12: 'commission_daily',
        13: 'commission_monthly',
        14: 'agent_daily',
        15: 'agent_monthly',
        16: 'interestrate',
        17: 'buy_canceled',
        18: 'sell_canceled',
        19: 'dividend',
        20: 'dividend_franked',
        21: 'tax',
        22: 'agent',
        23: 'so_compensation',
        24: 'bonus'
    },
    ls_state: {
        sell: {
            limit: 'sell_limit',
            stop: 'sell_stop'
        },
        buy: {
            limit: 'buy_limit',
            stop: 'buy_stop'
        }
    },
    dateRange: {
        day: 0,
        threedays: 1,
        week: 2,
        month: 3,
        threemonths: 4,
        all: 5,
        range: 6
    },
    defaultInvestAmount: 1, // min 1, max 10
    system: {
        loginSources: [
            {
                id: 3,
                name: 'Demo'
            },
            {
                id: 4,
                name: 'Live'
            }
        ],
        defaultLoginSource: 3
    },
    openPositionsPanel: {
        tabId: 0,
        templates: {
            'full': 'openPositions',
            'collapsed': 'collapsedOpenPositions'
        }
    },
    ordersPanel: {
        tabId: 1,
        templates: {
            'full': 'openPositions',
            'collapsed': 'collapsedOpenPositions'
        }
    },
    closedPositionsPanel: {
        tabId: 2,
        templates: {
            'full': 'closePositions',
            'collapsed': 'collapsedClosePositions'
        }
    },
    tradingAlerts: {
        tabId: 3,
        templates: {
            'full': 'tradingAlerts',
            'collapsed': 'tradingAlerts'
        }
    },
    economicCalendar: {
        tabId: 4,
        templates: {
            'full': 'economicCalendar',
            'collapsed': 'economicCalendar'
        }
    },
    dailyMarketUpdate: {
        tabId: 5,
        templates: {
            'full': 'dailyMarketUpdate',
            'collapsed': 'dailyMarketUpdate'
        }
    },
    chartRangeParams: [
        {title: "1min", id: 1, timeFrame: 1}, // 1 min
        {title: "5min", id: 2, timeFrame: 5}, // 5 min
        {title: "15min", id: 3, timeFrame: 15}, // 15 min
        {title: "30min", id: 4, timeFrame: 30}, // 30 min
        {title: "1hour", id: 5, timeFrame: 60}, // 60 min
        {title: "4hours", id: 6, timeFrame: 240}, // 4 hours
        {title: "1day", id: 7, timeFrame: 1440},
        {title: "1week", id: 8, timeFrame: 10080},
        {title: "1month", id: 9, timeFrame: 43200}
    ],
    chartTypes: [
        {type: 'candlestick'},
        {type: 'areaspline'},
        {type: 'ohlc'}
    ],
    notification: {
        error: 0,
        success: 1
    },
    validatorType: {
        notEmpty: 0,
        regex: 1,
        valueMatch: 2
    },
    regex: {
        onlyLatinCharacters: '^[a-zA-Z]+$',
        onlyLatinCharactersAndWhitespaces: '^[a-zA-Z\\s]+$',
        latinCharactersDigitsWhitespace: '^[a-zA-Z\\s0-9]+$',
        email: "[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?",
        onlyDigits: '^[0-9]+$'
    },
    classes: {
        inputErrorClass: 'error'
    },
    inputTypes: {
        text: 'text',
        password: 'password'
    },
    //all timeouts are in milliseconds
    timeout: {
        noResponse: 10000
    },
    defaultCurrency: 'USD',
    currencySymbols: {
        USD: '$',
        EUR: '€',
        GBP: '£',
        AUD: 'A$',
        CAD: 'C$',
        NZD: 'NZ$',
        SGD: '$',
        JPY: '¥',
        RUB: '₽',
        TRY: '₺',
        CNY: '¥',
        BRL: 'R$',
        ZAR: 'R',
        CHF: 'CHF',
        KWD: 'ك',
        SAR: 'SR',
        BTC: 'Ƀ',
        LTC: 'Ł',
        XRP: 'XRP',
        BCH: 'BCH',
        ETH: 'ETH',
        UST: '₮',
        CZK: 'Kč',
        HUF: 'Ft',
        TTR: '₮',
        SEK: 'SEK'
    },
    investAmountRangeParams: [
        {value: 1, name: '1'},
        {value: 5, name: '5'},
        {value: 10, name: '10'},
        {value: 50, name: '50'},
        {value: 100, name: '100'}
    ],
    startOfDay: {"hours": 6, "minutes": 55, "seconds": 1},
    profitLossOptions: [
        {id: 1, title: 'Points'},
        {id: 2, title: 'Rate'}
    ],
    defaultProfit: 50,
    defaultLoss: 50,

    error: {
        type: {
            'VALIDATION': 0,
            'SYSTEM': 1,
            'NETWORK': 2
        },
        typeById: {
            0: 'validation',
            1: 'system',
            2: 'network'
        }
    },

    daysOfWeek: {
        0: 'Sun',
        1: 'Mon',
        2: 'Tue',
        3: 'Wed',
        4: 'Thu',
        5: 'Fri',
        6: 'Sat'
    },

    loginStatus: {
        noActiveAccount: 0,
        failedActiveAccount: 1,
        noTradingAccounts: 2
    },

    userState: {
        initial: 1,
        personal: 2,
        questionnaire: 3
    },
    depositMultipliers: [1, 2.5, 2, 2, 2.5, 2],
    defaultDeposit: {
        minimum: 100,
        maximum: 5000,
        visual: 250
    },
    platforms: [
        "Web",
        "API",
        "CRM",
        "Mobile"
    ],
    platformById: {
        web: "Web",
        mobile: "Mobile",
        webMobile: "Web Mobile"
    },
    initialDeposit: 25000,
    documentCategories: [
        {
            'name': 'proof_of_identity',
        },
        {
            'name': 'proof_of_residence',
        },
        {
            'name': 'proof_of_payment',
        },
        {       // to show upload other documents - remove comment
            'name': 'document_other',
        },
    ],
    documentBaseCategories: [
        'photo_id',
        'passport',
        'driving_license',
        'utility_bill',
        'bank_statement',
        'residence_certificate',
        'credit_card_copy'
    ],
    documentTypes: [
        {id: 'photo_id_front', baseCategory: 'photo_id', category: 'proof_of_identity'},
        {id: 'photo_id_back', baseCategory: 'photo_id', category: 'proof_of_identity'},
        {id: 'passport', baseCategory: 'passport', category: 'proof_of_identity'},
        {id: 'driving_license_front', baseCategory: 'driving_license', category: 'proof_of_identity'},
        {id: 'driving_license_back', baseCategory: 'driving_license', category: 'proof_of_identity'},
        {id: 'utility_bill', baseCategory: 'utility_bill', category: 'proof_of_residence'},
        {id: 'bank_statement', baseCategory: 'bank_statement', category: 'proof_of_residence'},
        {id: 'residence_certificate', baseCategory: 'residence_certificate', category: 'proof_of_residence'},
        {id: 'credit_card_copy_front', baseCategory: 'credit_card_copy', category: 'proof_of_payment'},
        {id: 'credit_card_copy_back', baseCategory: 'credit_card_copy', category: 'proof_of_payment'}
    ],
    documentStatuses: {
        'new': 'New',
        'pending': 'Pending',
        'approved': 'Approved',
        'rejected': 'Rejected'
    },
    documentToStatuses: {
        'Pending': 'pending',
        'Approved': 'approved',
        'Rejected': 'rejected'
    },
    documentFromTypes: {
        'photo_id_front': 'Photo ID front',
        'photo_id_back': 'Photo ID back',
        'passport': 'Passport',
        'driving_license_front': 'Driving license front',
        'driving_license_back': 'Driver license back',
        'utility_bill': 'Utility bill',
        'bank_statement': 'Bank statement',
        'residence_certificate': 'Residence certificate',
        'credit_card_copy_front': 'Credit card copy front',
        'credit_card_copy_back': 'Credit card copy back',
        'other': 'Other'
    },
    documentToTypes: {
        'Photo ID front': 'photo_id_front',
        'Photo ID back': 'photo_id_back',
        'Passport': 'passport',
        'Driving license front': 'driving_license_front',
        'Driver license back': 'driving_license_back',
        'Utility bill': 'utility_bill',
        'Bank statement': 'bank_statement',
        'Residence certificate': 'residence_certificate',
        'Credit card copy front': 'credit_card_copy_front',
        'Credit card copy back': 'credit_card_copy_back'
    },
    fileTypes: [
        'image/png',
        'image/gif',
        'image/jpeg',
        'image/bmp',
        'image/TIFF',
        'application/pdf'
    ],
    maxFileSize: 10485760,
    minFileSize: 10000,
    ticketStatuses: {
        'open': 'Open',
        'inprogress': 'In Progress',
        'closed': 'Closed',
        'closedByClient': 'Closed By Client',
        'awaitingAgent': 'Awaiting Agent',
        'awaitingClient': 'Awaiting Client'
    },
    ticketToStatuses: {
        'Open': 'open',
        'In Progress': 'inprogress',
        'Closed': 'closed',
        'Closed By Client': 'closedByClient',
        'Awaiting Agent': 'awaitingAgent',
        'Awaiting Client': 'awaitingClient'
    },
    ticketTypes: {
        'generalQuestion': 'General Question',
        'loginProblem': 'Login Problem',
        'financeDepartment': 'Finance Department',
        'partnership': 'Partnership',
        'mobileClient': 'Mobile Client',
        'depositWithdrawal': 'Deposit or Withdrawal'
    },
    ticketToTypes: {
        'General Question': 'generalQuestion',
        'Login Problem': 'loginProblem',
        'Finance Department': 'financeDepartment',
        'Partnership': 'partnership',
        'Mobile Client': 'mobileClient',
        'Deposit or Withdrawal': 'depositWithdrawal'
    },
    paymentMethodsToTypes: {
        'Credit card': 'creditCard',
        'Wire transfer': 'wireTransfer',
        'Skrill': 'skrill',
        'Neteller': 'neteller',
        'CryptoWallet': 'cryptoWallet',
        'Other': 'other'
    },
    withdrawalReasons: {
        'withdrawingProfits': 'Withdrawing profits',
        'transferringFundsToAnotherBroker': 'Transferring funds to another broker',
        'unsatisfactoryService': 'Unsatisfactory service',
        'limitedFunds': 'Limited funds',
        'notEnoughTradingExperience': 'Not enough trading experience',
        'otherReason': 'Other reason'
    },
    withdrawRequestStatusToType: {
        'Pending': 'pending',
        'Approved': 'approved',
        'Rejected': 'rejected',
        'Cancelled by manager': 'cancelledByManager',
        'Cancelled by customer': 'cancelledByCustomer'
    },
    wiretransferDetails: {
        beneficiary_name: 'Maxiflex Global Investments Corp Limited',
        beneficiary_address: '46 Ayiou Athanasiou Ave, First Floor, Office 102, Cyprus',
        beneficiary_bank: 'Ceska Sporitenia Bank',
        bank_address: 'Ceska Sporitenia. a.s. Oibrachtova 1020/62, Prague',
        beneficiary_account_number: '6621342/0800',
        beneficiary_iban: 'CZ65 0800 0000 0000 0662 1342',
        swift: 'GIBAZ CZ PX',
        comments: '6260483 Ghandour'
    },
    showLeverageDropdown: true,
    depositActionName: 'forexDeposit',
    paymentMethodsBlueprint: {
        'jeton': 'Jeton',
        'zotapay': 'ZotapayHosted',
        'bitcobrokers': 'BitcoBrokers',
        'solid': 'SolidHosted',
        'bestpaycard': 'BestPayCard'
    },
    signupEnableCheckKYC: false,
    signupTermsExtended: true,
    externalLinks: {
        kycPolicy: "#",
        termsAndConditions: 'https://www.trademarkets.eu/legal/',
    },

    hidePhoneNumber: true,
    showCommission: false,
    skipCreateFirstAccountPage: true,
    autoUpdatePersonalDetails: false,
    transactionTypes: ['deposit', 'withdrawal', 'credit', 'all'],
    hideTransferBetweenAccounts: false,
    enable2FA: true,
    withdrawalComplianceRequired: false,
    //
    autoOpenLiveAccount: true,
    questionnairePopups: {
        6: 'repay_popup'
    },
    //questionnarie translation key overrides
    questionnaireAnswersOverrides: {
    },
    // creates additional demo account with FIRST live
    demoAccountCreateWithLive: true,
    // possible button actions: createAccount, close, logout
    scoringRules: [
        {
            classification: 'Rejected',
            live: 1,
            defaultLeverage: 30,
            leverages: [30],
            acceptPopup: true,
            showMessage: true,
            messageTranslationKey: 'rejected_customers'
        },
        {
            classification: 'Conditionally Accepted',
            live: 1,
            defaultLeverage: 30,
            leverages: [30],
            acceptPopup: true,
            showMessage: true,
            messageTranslationKey: 'conditionally_accepted'
        },
        {
            classification: 'Accepted',
            live: 1,
            defaultLeverage: 30,
            leverages: [30],
            acceptPopup: false,
            showMessage: false
        }
    ],
    questionnaireResetAnswerButton: true,
    profileFieldRules: {
        firstName: {
            required: true,
            rawName: 'firstName',
            scopes: {
                registration: {
                    hidden: false,
                    readonly: false,
                    readonlyIfNotEmpty: false
                },
                clientArea: {
                    hidden: false,
                    readonly: true,
                    readonlyIfNotEmpty: false
                }
            }
        },
        lastName: {
            required: true,
            rawName: 'lastName',
            scopes: {
                registration: {
                    hidden: false,
                    readonly: false,
                    readonlyIfNotEmpty: false
                },
                clientArea: {
                    hidden: false,
                    readonly: true,
                    readonlyIfNotEmpty: false
                }
            }
        },
        birthday: {
            required: true,
            rawName: 'birthday',
            scopes: {
                registration: {
                    hidden: false,
                    readonly: false,
                    readonlyIfNotEmpty: false
                },
                clientArea: {
                    hidden: false,
                    readonly: true,
                    readonlyIfNotEmpty: false
                }
            }
        },
        country: {
            required: true,
            rawName: 'country',
            scopes: {
                registration: {
                    hidden: false,
                    readonly: false,
                    readonlyIfNotEmpty: false
                },
                clientArea: {
                    hidden: false,
                    readonly: false,
                    readonlyIfNotEmpty: false
                }
            }
        },
        state: {
            required: true,
            rawName: 'state',
            scopes: {
                registration: {
                    hidden: false,
                    readonly: false,
                    readonlyIfNotEmpty: false
                },
                clientArea: {
                    hidden: false,
                    readonly: false,
                    readonlyIfNotEmpty: false
                }
            }
        },
        city: {
            required: true,
            rawName: 'city',
            scopes: {
                registration: {
                    hidden: false,
                    readonly: false,
                    readonlyIfNotEmpty: false
                },
                clientArea: {
                    hidden: false,
                    readonly: false,
                    readonlyIfNotEmpty: false
                }
            }
        },
        address: {
            required: true,
            rawName: 'address',
            scopes: {
                registration: {
                    hidden: false,
                    readonly: false,
                    readonlyIfNotEmpty: false
                },
                clientArea: {
                    hidden: false,
                    readonly: false,
                    readonlyIfNotEmpty: false
                }
            }
        },
        currency: {
            required: true,
            rawName: 'currency',
            scopes: {
                registration: {
                    hidden: false,
                    readonly: false,
                    readonlyIfNotEmpty: false
                },
                clientArea: {
                    hidden: true,
                    readonly: false,
                    readonlyIfNotEmpty: false
                }
            }
        },
        customerType: {
            required: false,
            rawName: 'customerType',
            scopes: {
                registration: {
                    hidden: true,
                    readonly: false,
                    readonlyIfNotEmpty: false
                },
                clientArea: {
                    hidden: true,
                    readonly: false,
                    readonlyIfNotEmpty: false
                }
            }
        },
        citizenship: {
            required: true,
            rawName: 'citizenship',
            scopes: {
                registration: {
                    hidden: false,
                    readonly: false,
                    readonlyIfNotEmpty: false
                },
                clientArea: {
                    hidden: false,
                    readonly: false,
                    readonlyIfNotEmpty: false
                }
            }
        },
        postCode: {
            required: true,
            rawName: 'postCode',
            scopes: {
                registration: {
                    hidden: false,
                    readonly: false,
                    readonlyIfNotEmpty: false
                },
                clientArea: {
                    hidden: false,
                    readonly: false,
                    readonlyIfNotEmpty: false
                }
            }
        },
        phone: {
            required: true,
            rawName: 'phone',
            scopes: {
                registration: {
                    hidden: false,
                    readonly: false,
                    readonlyIfNotEmpty: true
                },
                clientArea: {
                    hidden: true,
                    readonly: false,
                    readonlyIfNotEmpty: false
                }
            }
        },
        isUSCitizen: {
            required: true,
            rawName: 'usCitizen',
            scopes: {
                registration: {
                    hidden: false,
                    readonly: false,
                    readonlyIfNotEmpty: false
                },
                clientArea: {
                    hidden: true,
                    readonly: false,
                    readonlyIfNotEmpty: false
                }
            }
        },
        tin: {
            required: false,
            rawName: 'tin',
            scopes: {
                registration: {
                    hidden: false,
                    readonly: false,
                    readonlyIfNotEmpty: false
                },
                clientArea: {
                    hidden: true,
                    readonly: false,
                    readonlyIfNotEmpty: false
                }
            }
        },
        taxCountry: {
            required: false,
            rawName: 'taxCountry',
            scopes: {
                registration: {
                    hidden: false,
                    readonly: false,
                    readonlyIfNotEmpty: false
                },
                clientArea: {
                    hidden: true,
                    readonly: false,
                    readonlyIfNotEmpty: false
                }
            }
        },
        nationalId: {
            required: false,
            rawName: 'nationalId',
            scopes: {
                registration: {
                    hidden: false,
                    readonly: false,
                    readonlyIfNotEmpty: false
                },
                clientArea: {
                    hidden: true,
                    readonly: false,
                    readonlyIfNotEmpty: false
                }
            }
        },
        companyName: {
            required: false,
            rawName: 'companyName',
            scopes: {
                registration: {
                    hidden: false,
                    readonly: false,
                    readonlyIfNotEmpty: false
                },
                clientArea: {
                    hidden: true,
                    readonly: false,
                    readonlyIfNotEmpty: false
                }
            }
        },
        isMarried: {
            required: false,
            rawName: 'married',
            scopes: {
                registration: {
                    hidden: true,
                    readonly: false,
                    readonlyIfNotEmpty: false
                },
                clientArea: {
                    hidden: true,
                    readonly: false,
                    readonlyIfNotEmpty: false
                }
            }
        },
        isSpouse: {
            required: false,
            rawName: 'spouseAware',
            scopes: {
                registration: {
                    hidden: true,
                    readonly: false,
                    readonlyIfNotEmpty: false
                },
                clientArea: {
                    hidden: true,
                    readonly: false,
                    readonlyIfNotEmpty: false
                }
            }
        },
        birthPlace: {
            required: false,
            rawName: 'birthPlace',
            scopes: {
                registration: {
                    hidden: true,
                    readonly: false,
                    readonlyIfNotEmpty: false
                },
                clientArea: {
                    hidden: true,
                    readonly: false,
                    readonlyIfNotEmpty: false
                }
            }
        },
        tradingExperience: {
            required: true,
            rawName: 'tradingExperience',
            scopes: {
                registration: {
                    hidden: true,
                    readonly: false,
                    readonlyIfNotEmpty: false
                },
                clientArea: {
                    hidden: true,
                    readonly: false,
                    readonlyIfNotEmpty: false
                }
            }
        }
    },
    questionGroups: ['investor_information', 'knowledge_and_experience', 'financial_situation', 'investment_objectives'],
    viewQuestionnaireEnable: true,
    showQuestionnaireInfo: true,
    platformSelect: true,

    // creates additional live accounts on every platform besides the default one
    autoAdditionalAccounts: false,
    verificationProvider: 'internal-v2',
    wireTransferShowBankStateField: true,
    wireTransferShowBankBranchField: false,
    assetIntoRules: {
        underlyingAssetName: true,
        expiration: true,
        spread: true,
        digits: true,
        tradingConditions: false,
        lotValue: true,
        minMaxVolume: true,
        volumeStep: true,
        leverage: true,
        requiredMargin: true,
        swaps: true,
        tradingHours: true,
        description: true 
    },
});
